export default "__VITE_ASSET__CVksha0x__"